
import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'typesafe-actions';
import {
  closeDisplays,
  toggleLogin,
} from '../state/uiControl/uiControl.actions';
import {
  clearUserData
} from '../state/user/user.actions';
import Logo from '../assets/images/middle_logo.svg';
import { IconButton } from '@material-ui/core/';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from '@material-ui/core/styles';
// import capacity from '../assets/images/capacity.svg';

// import { isProd } from '../util';
// import { Display } from '../state/uiControl/uiControl.reducer';

const StyledIconButton = withStyles({
  root: {
    zIndex: 221,
    position: 'absolute',
    top: '52px',
    marginLeft: '5px',
  }
})(IconButton);

const isFeed = process.env.REACT_APP_SHOW_FEEDS;

export const Header: React.FC<HeaderProps> = ({
  selectedVoyage,
  selectedYear,
  userData,
  toggleLogin,
  clearUserData,
  closeDisplays,
  setShowExplorePopup,
}) => {

  return <React.Fragment>
    <StyledIconButton
      aria-label='Explore Voyages'
      onClick={() => {
        setShowExplorePopup(true);
        closeDisplays();
      }}
    >
      <MenuIcon />
    </StyledIconButton>
    <div className="header">
      <img alt="logo" src={Logo} onClick={() => { window.open('https://www.seabourn.com', '_blank'); }} className="middle-logo" />
    </div>

    <div className="selected-data-container">
      {selectedVoyage ? "> Seabourn " + selectedVoyage?.data.ship + " > " + selectedYear + " > " + selectedVoyage.name : ""}
    </div>
    {!isFeed && <div className="header-menu-items">
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.seabourn.com/en/us/find-travel-professional">
        Find A Travel Advisor
      </a>
      <a target="_self" rel="noopener noreferrer"
        href="tel:+1-800-442-4448">
        +1-800-442-4448
      </a>
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.seabourn.com/en/us/about/contact">
        Contact
      </a>
      <a target="_blank" rel="noopener noreferrer"
        href="https://www.seabourn.com/en/us/faq">
        FAQ
      </a>
      {<div onClick={() => {
        if (userData) {
          clearUserData();
          return;
        }
        toggleLogin();
      }}>
        {userData ? 'Log Out' : 'Login'}
      </div>}

    </div>}
  </React.Fragment>;

};

const mapStateToProps = (state: RootState) => {
  return {
    selectedVoyage: state.voyagesData.selectedVoyageData,
    selectedYear: state.voyagesData.selectedYear,
    userData: state.user.userData,
  };
};

const dispatchProps = {
  toggleLogin,
  clearUserData,
  closeDisplays,
};

type HeaderProps = ReturnType<typeof mapStateToProps> &
  typeof dispatchProps & { setShowExplorePopup: (isOpen: boolean) => void };

export default connect(
  mapStateToProps,
  dispatchProps
)(Header);